

/*** Dayglow sub bg color **/
jQuery(document).ready(function() {
  var items = $('.product_custom_dayglow .product__media-list li.product__media-item');
  var currentIndex = 0;

  function rotateItems() {
      items.removeClass('is-active');
      $('body').removeClass(function(index, className) {
          return (className.match(/\bbg-\S+/g) || []).join(' ');
      });

      var currentItem = $(items[currentIndex]);
      currentItem.addClass('is-active');

      var bgcolor = currentItem.attr('data-bgcolor');
      $('body').addClass(bgcolor);

      currentIndex = (currentIndex + 1) % items.length;
  }

  if (items.length > 0) {
      rotateItems();  
      setInterval(rotateItems, 5000);
  }
});
/****/


/*** animation slide **/
function setScrollSliderPosition() {
    var activeElement = jQuery(".top_menu ul li.active");
    if (activeElement.length) {
        var actWidth = activeElement.outerWidth();
        var actPosition = activeElement.position();
        if (actPosition) {
            jQuery(".scroll-slider").css({
                "left": actPosition.left,
                "width": actWidth
            });
        }
    }
}

jQuery(document).ready(function() {
    jQuery(".top_menu ul li a").click(function() {
        var parent = jQuery(this).parent();
        parent.addClass('active').siblings().removeClass('active');

        var position = parent.position();
        var width = parent.outerWidth();
        if (position) {
            jQuery(".scroll-slider").css({
                "left": position.left,
                "width": width
            });
        }
    });

    setTimeout(function() {
        setScrollSliderPosition();
    }, 350);
});

jQuery(window).on('load resize', function () {
    setTimeout(function() {
        setScrollSliderPosition();
    }, 300);
});



/***/

jQuery(document).ready(function($) {
    $(".accordion-section .roasters-accordion-title").click(function(e) {
        e.preventDefault();
        var content = $(this).closest(".accordion-section").find(".accordion-detail-sec");
        $(content).slideToggle(250);
    });
});

/** Subscription **/
const section = document.getElementsByClassName('subscription_menu')[0];   
if (section){
const parentDiv = section.closest("section");
parentDiv.classList.add('sticky'); 
}


/** FAQ **/
   jQuery(function ($) {
var $question = $('.accordion-faq-title');
var $answer = $('.faq-content');
$question.click(function(){
$answer.slideUp();
if($(this).hasClass('open')){
   $(this).removeClass('open')
            .next($answer).slideUp();
}else{
   $question.removeClass('open');
   $(this).addClass('open')
    .next($answer).slideDown();         
}
});
});

function fnTopSpace() {
  document.body.style.setProperty("--topSpace", document.querySelector("header").offsetHeight + 'px');
}

document.addEventListener('DOMContentLoaded', function() {
  fnTopSpace();
});

// Window Load with resize Event
window.addEventListener('load', function() {
  setTimeout(function() {
    fnTopSpace();
  }, 500);
});

window.addEventListener('resize', function() {
  setTimeout(function() {
    fnTopSpace();
  }, 500);
});

window.onscroll = function() {
  setTimeout(function() {
    fnTopSpace();
  }, 200);
};

/** Header Add class **/
window.scrollY > 80 ? document.body.classList.add('sticky') : document.body.classList.remove('sticky') 

window.addEventListener('scroll', function() {
    window.scrollY > 80 ? document.body.classList.add('sticky') : document.body.classList.remove('sticky') 
});

/*** Search Popup **/
// $(".filter-box button#opensearchform").click(function(){
//   $("body").toggleClass("Search-open");
// });

// /Learn more or less
document.addEventListener('DOMContentLoaded', function() {
    const learnMoreBtns = document.querySelectorAll('.learn-more-btn');

    learnMoreBtns.forEach(btn => {
        btn.addEventListener('click', function(event) {
            event.preventDefault(); 
            const learnMoreBox = this.parentElement.nextElementSibling;
          
            if (learnMoreBox.style.display === 'none') {
                learnMoreBox.style.display = 'block';
                const height = learnMoreBox.scrollHeight;
                learnMoreBox.style.height = '0px'; 
                learnMoreBox.animate(
                    { height: height + 'px' },
                    {
                        duration: 500,
                        easing: 'ease',
                        fill: 'both'
                    }
                );
                this.textContent = 'LESS';
            } else {
                learnMoreBox.animate(
                    { height: '0px' },
                    {
                        duration: 500,
                        easing: 'ease',
                        fill: 'both'
                    }
                );
                this.textContent = 'LEARN MORE';
                setTimeout(() => {
                    learnMoreBox.style.display = 'none';
                }, 500);
            }
        });
    });
});

/** subscription_menu **/ 
 
$(function() {
    // Function to read a cookie
    function getCookie(cookieName) {
        var name = cookieName + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var cookieArray = decodedCookie.split(';');
        for (var i = 0; i < cookieArray.length; i++) {
            var cookie = cookieArray[i];
            while (cookie.charAt(0) == ' ') {
                cookie = cookie.substring(1);
            }
            if (cookie.indexOf(name) == 0) {
                return cookie.substring(name.length, cookie.length);
            }
        }
        return null;
    }

    // Read the cookie
    var activeLiId = getCookie("active_li_id");

    // If cookie exists and is not empty, set active class on the corresponding li element
    if (activeLiId && $("#" + activeLiId).length) {
        $("#" + activeLiId).addClass("active");
    } else {
        // If cookie is not set or not found, activate the first <li> element
        $(".top_menu.subscription_menu li:first-child").addClass("active");
    }

    
    $(".top_menu li").click(function() {
        $(".top_menu.subscription_menu li.active").removeClass("active");
        var id = $(this).attr('id');
        setCookie("active_li_id", id, 1); // Set the clicked li's id as cookie
        $(this).addClass("active"); // Set the clicked li as active
    });

    $(".custom_click_cookie").click(function() {
      console.log('hello custom_click_cookee');
        $(".top_menu.subscription_menu li.active").removeClass("active");
        var id = $(this).attr('id');
        setCookie("active_li_id", id, 1); // Set the clicked li's id as cookie
        $(this).addClass("active"); // Set the clicked li as active
    });


    // Function to set a cookie
    function setCookie(cookieName, cookieValue, expiryDays) {
        var d = new Date();
        d.setTime(d.getTime() + (expiryDays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = cookieName + "=" + cookieValue + ";" + expires + ";path=/";
    }
});



/** subscription_menu end**/ 

// filter close outside click
function checkElement() {
  var element = $('#gf-open-filter');
  if (!element.length) return;
  if (!$._data(element.get(0), 'events')?.click) {
    element.on('click', function(event) {
      event.stopPropagation();
      $('.gf-filter-contents').slideToggle('fast');
      $('#gf-tree').toggleClass('filters-active');
    });
  }
  $(document).on('click', function(event) {
    var target = $(event.target);
    if (!target.closest('.gf-filter-contents').length && !target.is('#gf-open-filter')) {
      if ($('.gf-filter-contents').is(':visible')) {
        $('.gf-filter-contents').slideUp('fast');
        $('#gf-tree').removeClass('filters-active');
      }
    }
  });
}
 $(document).ready(function() {
  setTimeout(checkElement, 1500); 
});
// end filter close outside click


document.addEventListener('DOMContentLoaded', function() {
    var headerHeight = document.querySelector("header").offsetHeight;
    var type = window.location.hash.substr(1);

    if (type.trim().length !== 0) {
        var hasValue = "#" + type;
        var targetElement = document.querySelector(hasValue);

        if (targetElement) {
            setTimeout(function () {
                window.scrollTo({
                    top: targetElement.offsetTop - headerHeight,
                    behavior: 'smooth'
                });
            }, 500);
        }
    }

document.querySelectorAll('a[href*="#"]:not([href="#"], .tabs-links li a, [href="#recover"], [href="#login"] )').forEach(function(link) {
        link.addEventListener('click', function(event) {
            if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
                var target = document.querySelector(this.hash);
                target = target ? target : document.querySelector('[name=' + this.hash.slice(1) + ']');
                if (target) {
                    event.preventDefault();
                    window.scrollTo({
                        top: target.offsetTop - headerHeight,
                        behavior: 'smooth'
                    });
                }
            }
        });
    });
});


/** Filter Search Himanshu **/
document.addEventListener('DOMContentLoaded', function() {
    initializeSearchForm();

    window.addEventListener('resize', function() {
        initializeSearchForm();
    });
});

function initializeSearchForm() {
    setTimeout(function() {
        var button = $("#opensearchform");
        var tagList = $(".searchform-popup");

        if (button.length && tagList.length) {
            button.off('click').on('click', function(event) {
                console.log('Button clicked');
                event.stopPropagation();
               var searchInput = document.getElementById('daylg-searchinput');
                setTimeout(function() {
                  searchInput.focus();
                }, 500);
                $('.searchform-popup input.gf-controls-search-input').attr('autofocus', 'true');
                $("body").toggleClass("open-search");
            });

            $(".searchform-popup button.close").on('click', function(event) {
               $("body").removeClass("open-search");              
            });
          
            $(document).off('click').on('click', function(event) {
                if (!$(event.target).closest(tagList).length && !$(event.target).closest(button).length) {
                    $("body").removeClass("open-search");
                }
            });
        }
    }, 1500);
}



/** Tag filter **/

$(function() {
    var button = $(".tags_btn");
    var tagList = $(".stories-tag-list-group");

    if (button.length && tagList.length) {
        button.click(function(event) {              
            tagList.slideToggle();
            event.stopPropagation();
        });

        $(document).click(function(event) {
            if (!$(event.target).closest(tagList).length && !$(event.target).closest(button).length) {
                tagList.slideUp();
            }
        });
    }
});

/** Contract to hide coffees **/
document.addEventListener("DOMContentLoaded", function() {
    const hideCoffeesBtn = document.querySelector('.hide_coffees_btn');

    if (hideCoffeesBtn) {
        hideCoffeesBtn.addEventListener('click', function() {
            const roasterDesigns = document.querySelectorAll('.roaster-design');
            const accordionDetailSecs = document.querySelectorAll('.accordion-detail-sec');
            roasterDesigns.forEach(function(roasterDesign) {
                roasterDesign.classList.remove('active');
            });
            accordionDetailSecs.forEach(function(accordionDetailSec) {
                accordionDetailSec.style.display = 'none';
            });
        });
    }
});

/*** Slider Card Drower **/

